export interface ShareDeps {
  share: ((data: { title: string; url: string }) => Promise<void>) | undefined;
  writeText: (s: string) => Promise<void>;
  title: string;
}

export type ShareResult = { via: "share" } | { via: "clipboard" };

export async function shareOrCopyInviteUrl(url: string, deps: ShareDeps): Promise<ShareResult> {
  if (deps.share) {
    try {
      await deps.share({ title: deps.title, url });
      return { via: "share" };
    } catch {
      // user dismissed share — fall through to clipboard
    }
  }
  await deps.writeText(url);
  return { via: "clipboard" };
}
